export function formatUserName(user) {
    if (user.firstName && user.lastName)
        return `${user.firstName} ${user.lastName}`;
    if (user.firstName)
        return user.firstName;
    return user.email;
}
//# sourceMappingURL=format-user-name.js.map